import { forwardRef, useImperativeHandle, useRef } from 'react';

import cn from '@/utils/cn';

import { inputStyle, InputWrapper } from './Input';
import { InputMaskProps } from './Input.types';
import { IMaskInput } from 'react-imask';

const InputMask = forwardRef<HTMLInputElement, InputMaskProps>(
  (
    {
      className,
      success,
      error,
      disabled,
      value,
      classNameRightSection,
      label,
      rightSection,
      mask,
      ...props
    },
    ref
  ) => {
    const inputRef = useRef<HTMLInputElement>(null);

    useImperativeHandle(
      ref,
      () =>
        ({
          focus: () => inputRef.current?.focus(),
          select: () => inputRef.current?.select(),
        }) as HTMLInputElement,
      []
    );

    return (
      <InputWrapper
        value={value}
        error={error}
        classNameRightSection={classNameRightSection}
        success={success}
        label={label}
        rightSection={rightSection}
      >
        <IMaskInput
          eager={true}
          disabled={disabled}
          className={cn(
            inputStyle({
              error: !!error,
              success: !!success,
              disabled: disabled,
            }),
            className
          )}
          inputRef={inputRef}
          mask={mask}
          value={value}
          data-testid={`${props.name}-input`}
          {...props}
        />
      </InputWrapper>
    );
  }
);

InputMask.displayName = 'InputMask';

export { InputMask };
